import { styled } from '@mui/material/styles';
import FilterWrapper from '../FilterWrapper/index.js';

var PREFIX = "FilterTags";
var classes = {
    textfield: "".concat(PREFIX, "-textfield"),
    selectFormControl: "".concat(PREFIX, "-selectFormControl")
};
var StyledFilterTags = styled(FilterWrapper)(function () { return ({
    ".MuiOutlinedInput-input": { fontSize: "0.875rem", height: "inherit" }
}); });

export { classes, StyledFilterTags as default };
//# sourceMappingURL=index.styled.js.map
